module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai66-93e5be1aaf62dd0b742c35ba984fad80.jpg";